module.exports = __webpack_public_path__ + "img/20190430063252857.e5431cb7.jpg";